$('.slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    infinite: true,
  	fade: false,
  	autoplay: true,
  	autoplaySpeed: '4000',
  	speed: '500',
    cssEase: 'ease-out',
  waitForAnimate: true,
  prevArrow: false,
    nextArrow: false
});
